import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { PublishedSellerGuard } from './core/guards/published-seller.guard';
import { DraftSellerGuard } from './core/guards/draft-seller.guard';
import { SessionGuard } from './core/guards/session.guard';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/seller-landing/seller-landing.component')
      .then(m => m.SellerLandingComponent),
    canActivate: [SessionGuard]
  },
  {
    path: 'seller-registration',
    component : OtpVerificationComponent
  },

  {
    path: 'seller-registration/:partner_samhita_id',
    loadComponent: () => import('./pages/seller-registration/seller-registration.component')
    .then(m => m.SellerRegistrationComponent),
  },

  {
    path: 'seller-registration/:partner_samhita_id/:user_id',
    loadComponent: () => import('./pages/seller-registration/seller-registration.component')
    .then(m => m.SellerRegistrationComponent),
  },

  {
    path: 'seller-registration/:partner_samhita_id/:user_id/credit-survey',
    loadComponent: () => import('./pages/seller-registration/credit-survey/credit-survey.component')
    .then(m => m.CreditSurveyComponent),
  },

  // {
  //   path: 'marketplace',
  //   loadComponent: () => import('./pages/marketplace/marketplace.component')
  //     .then(m => m.MarketplaceComponent),
  // },
  {
    path: 'campaign/:id',
    loadComponent: () => import('./pages/campaign/campaign.component')
      .then(m => m.CampaignComponent),
  },
  {
    path: 'register/:seller_id',
    loadComponent: () => import('./pages/seller-registration/seller-registration.component')
      .then(m => m.SellerRegistrationComponent),
    canActivate: [AuthGuard,DraftSellerGuard]
  },
  {
    path: 'success/:id',
    loadComponent: () => import('./pages/seller-registration-success/seller-registration-success.component')
      .then(m => m.SellerRegistrationSuccessComponent),
    canActivate: [AuthGuard,PublishedSellerGuard]
  },
  // {
  //   path: 'products',
  //   loadComponent: () => import('./pages/products/products.component')
  //     .then(m => m.ProductsComponent),
  //   canActivate: [AuthGuard, PublishedSellerGuard]
  // },

  {
    path: 'credit-survey',
    loadComponent: () => import('./pages/seller-registration/credit-survey/credit-survey.component')
    .then(m => m.CreditSurveyComponent),
  },

  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];
